import React from 'react';
import { PropTypes } from 'prop-types';
import { map } from 'lodash';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classNames from 'classnames';

const SimpleNavTabs = ({ items, activeTab, style }) => {
  return (
    <Nav tabs style={style}>
      {map(items, item => (
        <NavItem key={item.name}>
          <NavLink href={`#${item.path}`} className={classNames({ active: activeTab === item.name })}>
            <h5>{item.name}</h5>
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

SimpleNavTabs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, path: PropTypes.string })).isRequired,
  activeTab: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export { SimpleNavTabs };
